module.exports = __webpack_public_path__ + "img/episode3.eb440489.png";